<div *ngIf="formGroup">
  <form [formGroup]="formGroup" formFocusable>
    <app-default-card
      [title]="'Einverständniserklärung'"
      [showThisComponent]="true"
      [showChildComponent]="true">
      <app-accept-conditions
        [inputForm]="formGroup"
        [controlName]="'formConfirmation'"
        [disable]="false"
        [inputLink]=""
        [inputText]="'customerFeedInAcceptance' | uiAdaptionValue"></app-accept-conditions>
    </app-default-card>
  </form>
</div>
